import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { faqs } from '../data/testimonials';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
export function Faq() {
  const {
    t
  } = useLanguage();
  const [openId, setOpenId] = useState<string | null>(faqs[0].id);
  return <section id="faq" className="w-full bg-navy-50/60 py-20 sm:py-24" data-id="element-88" data-mp="2dz4slnkqwi8z">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-4 sm:px-6 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16 lg:px-8" data-id="element-89" data-mp="2913c9aepex17">
        <Reveal data-id="element-90" data-mp="240yxppxcwcdm">
          <SectionHeading eyebrow={t('faq.eyebrow')} title={t('faq.title')} data-id="element-91" data-mp="240fe84s25fxh" />
        </Reveal>

        <Reveal delay={0.06} data-id="element-92" data-mp="1z2xcozgde2zi">
          <ul className="divide-y divide-navy-900/10 border-y border-navy-900/10" data-id="element-93" data-mp="sn3h0cqszvka">
            {faqs.map(faq => {
            const isOpen = openId === faq.id;
            return <li key={faq.id} data-id="element-94" data-mp="nqczrm39itxa">
                  <h3 data-id="element-95" data-mp="pho9dqw2hklk">
                    <button type="button" onClick={() => setOpenId(isOpen ? null : faq.id)} aria-expanded={isOpen} aria-controls={`faq-panel-${faq.id}`} className="flex w-full items-start justify-between gap-6 py-5 text-left" data-id="element-96" data-mp="pj92dc2qgvhb">
                      <span className="font-display text-base font-bold text-navy-900 sm:text-lg" data-id="element-97" data-mp="6rq0j8kg3ngv">
                        {t(faq.questionKey)}
                      </span>
                      <PlusIcon className={`mt-0.5 h-5 w-5 shrink-0 text-amber-600 transition-transform duration-200 ease-smooth ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-98" data-mp="bjzq2nhnelim" />
                    </button>
                  </h3>
                  <AnimatePresence initial={false} data-id="element-99" data-mp="3nyigum1q0yf3">
                    {isOpen ? <motion.div id={`faq-panel-${faq.id}`} key="panel" initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.24,
                  ease: [0.23, 1, 0.32, 1]
                }} className="overflow-hidden" data-id="element-100" data-mp="1uh4c9itl6gvq">
                        <p className="max-w-2xl pb-6 pr-10 text-[15px] leading-relaxed text-navy-900/70" data-id="element-101" data-mp="2ddcm6zxjnfxd">
                          {t(faq.answerKey)}
                        </p>
                      </motion.div> : null}
                  </AnimatePresence>
                </li>;
          })}
          </ul>
        </Reveal>
      </div>
    </section>;
}